import { Component, Input, OnInit, OnChanges, OnDestroy, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AffiliateManager } from 'projects/fantasy-shared/src/services/affiliatemanager.service'
import { ConfigConstants } from 'config-constants';
import { Subscription } from 'rxjs';
import {DomSanitizer,SafeResourceUrl,} from '@angular/platform-browser';

@Component({
  selector: 'app-fsb-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FsbFooterComponent implements OnInit, OnChanges, OnDestroy {

  year: number;
  version: string = '';
  @Input('container') container: boolean;
  @Input('isLanding') isLanding: boolean;
  affliateName: any;
  privacyPolicyLink : string = '';
  cookiePolicyLink : string = '';
  tncLink : string = '';
  affStoreSub: Subscription;
  footerUrl: SafeResourceUrl;

  constructor(
    private affManager: AffiliateManager,
    public sanitizer:DomSanitizer
  ) { 
    this.footerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(ConfigConstants.FSB_FOOTER_IFRAME_URL);      
  }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
    this.version = ConfigConstants.APP_VERSION;
    this.affStoreSub = this.affManager.affiliateObserver.subscribe(res => {
    this.updateLinks();
    });
    console.log(this.footerUrl)
    // this.updateLinks();
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent): void {
    if (event.origin !== new URL(ConfigConstants.FSB_FOOTER_IFRAME_URL).origin) {
      return;
    }

    if (window.parent !== window) {
      window.parent.postMessage(event.data, '*');
    }
  }

  ngOnChanges() {
    this.affliateName = this.affManager.getAffName();
    this.updateLinks();
  }

  updateLinks() {
    this.affliateName = this.affManager.getAffName();
    this.privacyPolicyLink = this.affManager.getPrivacyPolicyLink();
    this.cookiePolicyLink = this.affManager.getCookieLink();
    this.tncLink = this.affManager.getTnCLink();
  }

  gambleAwareNav(){
    console.log("click")
  }

  ngOnDestroy(): void {
    if (this.affStoreSub) {
      this.affStoreSub.unsubscribe();
    }
  }

}
